export enum mobileIdPathEnum {
    FORGOT_PASSWORD = 'forgotPassword',
    UPDATE_PROFILE = 'updateProfile',
    BUSINESS_AUTH = 'businessAuth',
    GOVERNMENT_AUTH = 'governmentAuth',
    FAMILY_SIGN_UP = 'familySignUp',
    CIVILID_SIGN_IN = 'civilIdSignIn'
}